// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2xxAc","emails":"CreateEditClinics_emails__YM7_t","emailTagLabel":"CreateEditClinics_emailTagLabel__20jnm"};